// src/components/NotificationSystem.js (Mejorado)

import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { removeNotification } from "../../store/notificationSlice";
import styles from "./notificationSystem.module.css";

// Mapa de iconos para cada tipo de notificación
const iconMap = {
  success: "check-circle", // Necesitarás añadir estos iconos a tu componente Icon si no existen
  error: "times-circle",
  warning: "exclamation-triangle",
  info: "info-circle",
};

const Notification = ({ notification }) => {
  const dispatch = useDispatch();
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (!notification.isPersistent) {
      const timer = setTimeout(() => {
        handleClose();
      }, notification.timeout);

      return () => clearTimeout(timer);
    }
  }, [notification]);

  const handleClose = () => {
    setIsExiting(true);
    // Espera a que termine la animación de salida antes de eliminar del store
    setTimeout(() => {
      dispatch(removeNotification(notification.id));
    }, 300); // La duración debe coincidir con la animación en CSS
  };

  const IconComponent = iconMap[notification.type] || "info-circle";

  return (
    <div
      className={`${styles.notificationItem} ${styles[notification.type]} ${
        isExiting ? styles.exiting : ""
      }`}
      role="alert"
    >
      <i className={`fa fa-${IconComponent} ${styles.icon}`}></i>
      <div className={styles.contentWrapper}>
        <p className={styles.messageText}>{notification.message}</p>
        {!notification.isPersistent && (
          <div className={styles.progressBar}></div>
        )}
      </div>
      <button
        onClick={handleClose}
        className={styles.closeButton}
        aria-label="Cerrar"
      >
        &times;
      </button>
    </div>
  );
};

const NotificationSystem = () => {
  const notifications = useSelector((state) => state.notifications);

  return (
    <div className={styles.notificationContainer}>
      {notifications.map((notification) => (
        <Notification key={notification.id} notification={notification} />
      ))}
    </div>
  );
};

export default NotificationSystem;
